(() => {
  'use strict';
  if (window.WUBProductReviews?.version === 2) return;
  function cleanUrl() { return window.location.pathname + window.location.search; }
  function scrollToReviews(event) {
    const target = document.getElementById('product-reviews');
    if (!target) return;
    event?.preventDefault?.();
    const url = cleanUrl();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history?.replaceState) window.history.replaceState(null, '', url);
  }
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-product-review-summary-link]')) return;
    scrollToReviews(event);
  });
  window.WUBProductReviews = Object.freeze({ version: 2, scrollToReviews });
})();
